import { render, staticRenderFns } from "./OwnerSubscriptionPanel.vue?vue&type=template&id=2db8589b"
import script from "./OwnerSubscriptionPanel.vue?vue&type=script&lang=js"
export * from "./OwnerSubscriptionPanel.vue?vue&type=script&lang=js"
import style0 from "./OwnerSubscriptionPanel.vue?vue&type=style&index=0&id=2db8589b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports